import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
} from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import { getFlashcardTypes } from '../../actions/flashcardTypes';
import CardTypeForm from './CardTypeForm';

const roleColor = (role) => (role === 'question' ? 'primary' : 'secondary');

const CardTypes = () => {
  const flashcardTypes = useSelector((state) => state.flashcardTypes);
  const [open, setOpen] = useState(false);
  const [currentId, setCurrentId] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFlashcardTypes());
  }, [dispatch]);

  const handleClickCreate = () => {
    setCurrentId(0);
    setOpen(true);
  };

  const handleClickEdit = (id) => {
    setCurrentId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(getFlashcardTypes());
  };

  const selectedType =
    currentId !== 0
      ? flashcardTypes.find((t) => t._id === currentId)
      : undefined;

  return (
    <div>
      <h2>Card Types</h2>
      {open && (
        <CardTypeForm
          cardType={selectedType}
          currentId={currentId}
          close={handleClose}
        />
      )}
      <TableContainer component={Paper}>
        <Table size="small" aria-label="card types table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Fields</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {flashcardTypes.map((ct) => (
              <TableRow key={ct._id}>
                <TableCell component="th" scope="row">
                  {ct.name}
                </TableCell>
                <TableCell>
                  {(ct.fields || []).map((f, i) => (
                    <Chip
                      key={i}
                      label={`${f.label} (${f.fieldType})`}
                      color={roleColor(f.role)}
                      size="small"
                      variant="outlined"
                      style={{ marginRight: 4, marginBottom: 2 }}
                    />
                  ))}
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    size="small"
                    onClick={() => handleClickEdit(ct._id)}
                    aria-label="Edit card type"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <IconButton onClick={handleClickCreate} aria-label="Create card type">
        <AddCircleIcon />
      </IconButton>
      create card type
    </div>
  );
};

export default CardTypes;
